import { AppHeader } from './AppHeader.tsx';
import type { PublicOrganization } from '@dermalink/shared';
import { practiceBrandingStyle } from '../hooks/usePublicOrganization.ts';
import { Copyright } from './PageLayout.tsx';
import styles from './AuthPageShell.module.css';

interface AuthPageShellProps {
  children: React.ReactNode;
  /** CSS max-width value for the main content column. Default: var(--max-width-wide) */
  maxWidth?: string;
  /** Top padding of the main content area. Default: var(--space-5) */
  padTop?: string;
  /** Horizontal padding of the main content area. Default: var(--space-5) */
  padX?: string;
  /** When true, main becomes a flex column (e.g. for full-height layouts like ConversationThread). */
  flexMain?: boolean;
  /** Patient home / conversation: blurred photo backdrop behind the content column (wider screens only). */
  patientBackdrop?: boolean;
  /** Brands the page for this practice: its backdrop (implies patientBackdrop), brand colour, and name in the header. */
  practice?: PublicOrganization | null;
  hideNav?: boolean;
  hideFooter?: boolean;
}

export function AuthPageShell({
  children,
  maxWidth,
  padTop,
  padX,
  flexMain = false,
  patientBackdrop = false,
  practice,
  hideNav = false,
  hideFooter = false,
}: AuthPageShellProps) {
  const pageClass = `${styles.page}${patientBackdrop || practice?.backdrop_url ? ` ${styles.pagePatientBackdrop}` : ''}`;
  const mainClass = `${styles.main}${flexMain ? ` ${styles.mainFlex}` : ''}`;
  const innerStyle = {
    ...(maxWidth ? { '--_max-width': maxWidth } : {}),
    ...(padTop   ? { '--_pad-top':  padTop   } : {}),
    ...(padX     ? { '--_pad-x':    padX     } : {}),
  } as React.CSSProperties;

  return (
    <div className={pageClass} style={practiceBrandingStyle(practice)}>
      <AppHeader hideNav={hideNav} practice={practice} />
      <main className={mainClass}>
        <div className={styles.mainInner} style={Object.keys(innerStyle).length ? innerStyle : undefined}>
          {children}
        </div>
      </main>
      {!hideFooter && (
        <footer className={styles.footer}>
          <Copyright />
        </footer>
      )}
    </div>
  );
}
